export const INTRAORAL_MASTERS = [
  {
    key: "general",
    label: "General Mouth & Soft Tissue",
    emptyText: "No General Mouth & Soft Tissue findings found.",
    templateFile: "intraoral_general_findings_template.xlsx",
    exportFile: "intraoral_general_findings_export.xlsx",
  },
  {
    key: "tooth",
    label: "Odontogram Tooth Findings",
    emptyText: "No Odontogram Tooth Findings found.",
    templateFile: "intraoral_tooth_findings_template.xlsx",
    exportFile: "intraoral_tooth_findings_export.xlsx",
  },
];

export const NAME_PATTERN = /^[a-zA-Z0-9\s/\\&\-(),.']+$/;
export const NAME_MAX = 255;
export const VALUE_MAX = 200;

export const toValueList = (values) =>
  (Array.isArray(values) ? values : [])
    .map((item) => (typeof item === "string" ? item : item?.name))
    .filter(Boolean);

export const cleanValues = (values) => {
  const seen = new Set();
  const cleaned = [];
  const duplicates = [];

  toValueList(values).forEach((raw) => {
    const value = String(raw).trim();
    if (!value) return;
    const key = value.toLowerCase();
    if (seen.has(key)) {
      duplicates.push(value);
      return;
    }
    seen.add(key);
    cleaned.push(value);
  });

  return { values: cleaned, duplicates };
};

export const validateFindingForm = ({ name, values = [] }) => {
  const trimmed = String(name ?? "").trim();
  if (!trimmed) return "Finding is required";
  if (trimmed.length < 2) return "Use at least 2 characters";
  if (trimmed.length > NAME_MAX) return `Use at most ${NAME_MAX} characters`;
  if (!NAME_PATTERN.test(trimmed)) {
    return "Only letters, numbers and - / & ( ) , . ' are allowed";
  }
  if (toValueList(values).some((value) => String(value).trim().length > VALUE_MAX)) {
    return `Each sub value must be at most ${VALUE_MAX} characters`;
  }
  return "";
};

/** Name and values only: clinic and source are decided by the server. */
export const buildFindingPayload = ({ name, values = [] }) => ({
  name: String(name ?? "").trim(),
  values: cleanValues(values).values.map((value) => ({ name: value })),
});

export const importFailures = (data = {}) => {
  const failed = (Array.isArray(data?.results) ? data.results : [])
    .filter((item) => item?.status === "failed")
    .map((item) => ({
      row: Number(item.row) || null,
      name: String(item.name ?? ""),
      reason: String(item.message ?? "Could not import this row"),
    }));

  const unreadable = (Array.isArray(data?.skippedRows) ? data.skippedRows : []).map(
    (item) => ({
      row: Number(item?.row) || null,
      name: String(item?.name ?? ""),
      reason: String(item?.reason ?? "Could not read this row"),
    })
  );

  return [...failed, ...unreadable].sort(
    (a, b) => (a.row ?? Infinity) - (b.row ?? Infinity)
  );
};

export const importSummary = (data = {}) => {
  const { created = 0, updated = 0, skipped = 0, failed = 0 } = data || {};
  const unreadable = Array.isArray(data?.skippedRows) ? data.skippedRows.length : 0;

  return {
    level: failed > 0 || unreadable > 0 ? "warning" : "success",
    message: `Import complete — ${created} created, ${updated} updated, ${skipped} skipped, ${
      failed + unreadable
    } failed.`,
  };
};
